import { Drawer } from 'antd';
import styled from 'styled-components';

export const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  background: #fff;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 8px 8px 16px;
  border-bottom: 1px solid #f0f0f0;
`;

export const Title = styled.h2`
  flex: 1;
  min-width: 0;
  padding-top: 10px;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  color: #262626;
`;

export const CloseButton = styled.button`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  font-size: 14px;
  color: #262626;
  cursor: pointer;
  background: none;
  border: none;
`;

export const Content = styled.div`
  flex: 1 0 auto;

  &::after {
    display: block;
    height: calc(24px + env(safe-area-inset-bottom, 0px));
    content: '';
  }
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  padding: 12px 16px 16px;
  background: #fff;
  border-top: 1px solid #d9d9d9;
`;

export const Panel = styled(Drawer)`
  && .ant-drawer-content-wrapper {
    width: 360px !important;
    max-width: 100vw;
  }

  && .ant-drawer-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
`;
